import ItemsDetailsMobileWrapper from 'components/ItemsDetailsMobileWrapper'
import ItemHeader from 'containers/ManageAccess/ItemHeader'
import { useIsSmallScreen } from 'packages/core'
import { Loader } from 'packages/eid-ui'
import { useCredentialHistory } from 'hooks'
import CredentialHistoryDetails from './CredentialHistoryDetails'
import { ManageAccessDrawer } from 'components/Drawer/ManageAccessDrawer'

const CredentialHistoryDrawer = ({ id, attributes, toggleDrawer, ...rest }) => {
    const isSmallScreen = useIsSmallScreen()
    const headerAttribute = attributes.find((x) => x.isHeader)

    const { data: credentialHistoryDetails } = useCredentialHistory(id)

    let item
    if (credentialHistoryDetails) {
        item = {
            resource: credentialHistoryDetails,
        }
    }

    const itemDetails = <CredentialHistoryDetails item={item} {...rest} />

    return isSmallScreen ? (
        <ItemsDetailsMobileWrapper toggleDrawer={toggleDrawer}>
            <ItemHeader title={item?.resource?.[headerAttribute.name]} />
            {!item && <Loader />}
            {item && itemDetails}
        </ItemsDetailsMobileWrapper>
    ) : (
        <ManageAccessDrawer
            id={id}
            toggleDrawer={toggleDrawer}
            item={item}
            itemDetails={itemDetails}
            headerAttribute={headerAttribute}
        />
    )
}

export default CredentialHistoryDrawer
